module.exports = __webpack_public_path__ + "img/20200317_open_API_technology_entrepreneurial_journey_sharing.d6d66038.jpg";